import { render, staticRenderFns } from "./orderCancelDialog.vue?vue&type=template&id=0bb2b95c&scoped=true&"
import script from "./orderCancelDialog.vue?vue&type=script&lang=js&"
export * from "./orderCancelDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderCancelDialog.vue?vue&type=style&index=0&id=0bb2b95c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb2b95c",
  null
  
)

export default component.exports